<template lang="html">
  <div class="text-center">
    <p>
      {{ title }}: {{ rating }}&nbsp;&nbsp;
      <b-icon
        font-scale="1"
        v-for="n in Math.floor(rating)" :key="`filled-${n}`"
        variant="primary"
        icon="star-fill"
        aria-hidden="true"
      ></b-icon>
      <span class="star-empty-block">
        <b-icon
          font-scale="1"
          v-for="n in (5 - Math.floor(rating))" :key="`empty-${n}`"
          variant="secondary"
          icon="star"
          aria-hidden="true"
        ></b-icon>
      </span>
    </p>
  </div>
</template>

<script>
import { BIcon, BIconStarFill, BIconStar, BIconStarHalf } from 'bootstrap-vue'

export default {
  name: 'RatingCustom',
  components: {
    BIcon,
    BIconStarFill,
    BIconStar,
    BIconStarHalf
  },
  props: {
    title: String,
    rating: Number
  }
}
</script>

<style lang="less">
  .star-empty-block {
    margin-left: -4px;
  }
</style>




// WEBPACK FOOTER //
// src/components/utils/RatingCustom.vue